/* eslint-disable no-unused-vars */
import { post, postDownloadImage } from "../config";

export function SearchInstallment({ body }) {
  return post({ url: `/api/aunjai/installment`, body });
  // body = borrower_id
}
export function RegisterLoan({ body }) {
  return post({ url: `/api/aunjai/registerLoan`, body });
  // body = ดูจาก swagger (ค่อนข้างละเอียด)
}
export function UploadAttachment({ body }) {
  return post({ url: `/api/aunjai/attachment`, body });
  // body = { loan_id,file_name,data } data = img base64 (อาจมีเปลี่ยนแปลง)
}
export function UpdateLoan({ body }) {
  return post({ url: `/api/aunjai/updateLoan`, body });
  // body = ดูจาก swagger (ค่อนข้างละเอียด)
}

export function GetLoans() {
  return post({ url: `/api/aunjai/product` });
}

export async function DownloadAttachment({ body }) {
  const blob = await postDownloadImage({
    url: "/api/aunjai/downloadAttachment",
    body,
  });

  const blobUrl = URL.createObjectURL(blob);

  return blobUrl;
}


export async function DownloadAttachmentContract({ body }) {
  const blob = await postDownloadImage({
    url: "/api/aunjai/downloadAttachment",
    body,
  });

  return blob; // ← return Blob directly, don't createObjectURL here
}



export function CreatePayment({ body }) {
  return post({ url: `/api/aunjai/payment`, body });
}
